import {
    useCallback, useMemo,
} from 'react'
import omit from 'lodash/omit'
import {
    useNavigate,
} from 'react-router-dom'

import {
    REDIRECT_PARAM,
} from 'app/shared-components/SkyNetTable/hooks/useAddCopiedItemWorkaround'
import StatusHandler from 'app/shared-components/StatusHandler'
import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import request from 'app/requests/Lane/Lane.requests'
import WarningCard from 'app/shared-components/WarningCard'

import useGetAccountLane from '../hooks/useGetAccountLane'
import AccountLaneForm from '../AccountLaneForm'

const AccountLaneCopy = ({
    id,
}: { id: number }) => {
    const navigate = useNavigate()
    const {
        Lanes: LanesRoutes,
    } = useAccountManagementRoutes()

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetAccountLane(id)

    const value = useMemo(() => {
        return {
            ...omit(data, [
                'id',
                'changedBy',
                'changedOn',
                'laneStatus',
            ]),
            originId: id,
        }
    }, [
        data,
        id,
    ])

    const onSuccess = useCallback(({
        id: copyId,
    }) => {
        invalidate()

        LanesRoutes.Overview.navigate({
            params: {
                key: copyId,
            },
            options: {
                state: REDIRECT_PARAM,
            },
        })
    }, [
        invalidate,
        LanesRoutes.Overview,
    ])

    const onCancel = useCallback(() => {
        navigate('..')
    }, [navigate])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <WarningCard>
                    You are copying a Lane.
                </WarningCard>
                <AccountLaneForm
                    data={value}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                    requestParam={request.createByAccount()}
                />
            </>
        </StatusHandler>
    )
}

export default AccountLaneCopy
